<template>
  <div class="app-main-inner">
    <!-- 新增/编辑 收/付款 弹窗 -->
    <el-dialog
      v-if="!dialogDistroy"
      no="realSendReceiveDialog"
      class="realSendReceiveDialog"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :width="$selectByLang('360px', '400px')"
      top="5vh"
    >
      <el-form :label-width="$selectByLang('85px', '130px')" label-position="left">
        <!--结算对象-->
        <el-form-item :label="$t('WriteOff.settleAccountsTo')">
          <cargo-company-select
            no="settlementCompanyId"
            :method-params="{active:true}"
            :default-value="Number(settlementCompanyId)||''"
            :tag-name="tagName"
            :custom-style="formItemWidth"
            @change="companyIdChangeHandler"
          />
        </el-form-item>
        <el-form :label-width="$selectByLang('85px', '130px')" label-position="left" :disabled="lockRecordButton">
          <!--收款方式-->
          <el-form-item :label="lbPayReceive + $t('WriteOff.method')">
            <cargo-advance-select
              no="receiveType"
              :clearable="false"
              :select-type="selectTypeNames.local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES"
              :cache="false"
              :default-value="receiveType"
              :static-options="receiveTypeArray"
              :style="formItemWidth"
              :tag-name="tagName"
              @parentCallBack="receiveTypeChangeHandler"
            />
          </el-form-item>
          <!--水单状态-->
          <el-form-item :label="$t('WriteOff.bankReceiptStatus')">
            <cargo-advance-select
              no="cashTransferState"
              :select-type="selectTypeNames.local_cache_ClearingConstants$CASH_TRANSFER_STATES"
              callback-method-type="value"
              :default-value="cashTransferState"
              :callback-params="{key:'cashTransferState'}"
              :clearable="false"
              :style="formItemWidth"
              :tag-name="tagName"
              @parentCallBack="cashTransferStateChangeHandler"
            />
          </el-form-item>
          <!--销账抬头-->
          <el-form-item :label="$t('CargoMsg.Cargo_WriteOffHeader')">
            <cargo-advance-select
              no="actualAmountTitle"
              :select-type="selectTypeNames.static_data_InvoiceTitle"
              filterable
              :cache="false"
              :default-value="actualAmountTitle"
              :static-options="ourInvoiceTitleArray"
              @parentCallBack="actualAmountTitleChangeEvent"
            />
          </el-form-item>
          <!--我方银行-->
          <el-form-item :label="$t('WriteOff.ourSideBank')">
            <cargo-advance-select
              no="ourBankAccountId"
              filterable
              :select-type="selectTypeNames.static_data_BankAccount"
              :cache="false"
              :method-params="{officeUuid:currentOfficeUuid}"
              :default-value="ourBankAccountId"
              :static-options="ourBankAccountArray"
              :custom-label="ourBankAccountLabel"
              :style="formItemWidth"
              options-width="450px"
              @parentCallBack="ourBankChangeHandler"
            />
          </el-form-item>
          <!--我方账号-->
          <el-form-item :label="$t('WriteOff.ourSideAccount')">
            <el-input v-model="ourBankAccountNo" no="ourBankAccountNo" disabled :style="formItemWidth" />
          </el-form-item>
          <!--凭证号-->
          <el-form-item :label="$t('WriteOff.proofNo')">
            <el-input v-model="actualAmount.voucherNo" no="voucherNo" :style="formItemWidth" />
          </el-form-item>
        </el-form>
        <!--使用收/付款记录-->
        <el-button
          v-if="showRecordButton"
          no="actualAmountRecord"
          type="primary"
          style="margin-bottom:10px"
          @click="actualAmountRecordHandler"
        >{{ recordButtonText }}</el-button>
        <el-form :label-width="$selectByLang('85px', '130px')" label-position="left" :disabled="lockRecordButton">
          <!--币种-->
          <el-form-item :label="$t('WriteOff.currency')">
            <cargo-advance-select
              no="currency"
              filterable
              :select-type="selectTypeNames.basic_data_Currency"
              :default-value="currency"
              :clearable="false"
              :style="formItemWidth"
              @parentCallBack="currencyChangeHandler"
            />
          </el-form-item>
          <!--收/付款金额-->
          <el-form-item :label="lbAmount">
            <el-input-number
              v-model="actualAmount.amount"
              no="amount"
              :min="0"
              :precision="2"
              controls-position="right"
              :style="formItemWidth"
            />
          </el-form-item>
          <!--对方单位-->
          <el-form-item :label="$t('WriteOff.theOppositeSideCompany')">
            <el-input v-model="actualAmount.paymentCompany" no="paymentCompany" :style="formItemWidth" />
          </el-form-item>
          <!--对方银行-->
          <el-form-item :label="$t('WriteOff.theOppositeSideBank')">
            <el-input v-model="actualAmount.companyBank" no="companyBank" :style="formItemWidth" />
          </el-form-item>
          <!--对方账号-->
          <el-form-item :label="$t('WriteOff.theOppositeSideAccount')">
            <el-input v-model="actualAmount.companyBankAccount" no="companyBankAccount" :style="formItemWidth" />
          </el-form-item>
        </el-form>
        <!--收/付款日期-->
        <el-form-item :label="lbPayDate">
          <el-date-picker
            v-model="actualAmount.payReceiveDate"
            no="payReceiveDate"
            value-format="yyyy-MM-dd"
            type="date"
            :clearable="false"
            :style="formItemWidth"
          />
        </el-form-item>
        <!--预收付备注-->
        <el-form-item :label="$t('Payment.preRemarks')">
          <el-input v-model="actualAmount.preRemark" no="preRemark" type="textarea" :rows="3" :style="formItemWidth" />
        </el-form-item>
        <!--票据号-->
        <el-form-item v-show="showTicketNo" :label="$t('Payment.ticketNo')">
          <el-input v-model="actualAmount.ticketNo" no="ticketNo" type="text" :maxlength="30" :style="formItemWidth" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!--保存并新增-->
        <el-button no="saveAndAdd" type="primary" @click="saveOrSaveAndAddHandler(false)">{{ $t('Payment.saveAndAdd') }}</el-button>
        <el-button no="save" type="primary" @click="saveOrSaveAndAddHandler(true)">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 选择实收实付记录 弹窗 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      no="realSendReceiveDialog2"
      :visible.sync="realSendReceiveDialog.visible"
      :title="$t('Clearing.SelectActualReceiptAndPayment')"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      top="4vh"
      custom-class="app-main-content"
      @closed="closedHandler"
    >
      <write-off-search
        v-if="realSendReceiveDialog.visible"
        ref="searchItem"
        config-module="510"
        grid-config-module="191002"
        :ar="realSendReceiveDialog.ar"
        :is-prepay="realSendReceiveDialog.isPrepay"
        :is-real-send-receive="realSendReceiveDialog.isRealSendReceive"
        :show-simple="false"
        grid-height="height: 400px"
        :is-dialog="true"
        @clickedCallBack="row => realSendReceiveDialog.dialogClickRow = row"
      />
      <div slot="footer">
        <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel2" @click="realSendReceiveDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiCacheManage } from '@/utils/commonUtil'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import writeOffSearch from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffSearch'
import { getLoading } from '@/utils/utilBaseElement'
import * as actualAmountApi from '@/api/clearing/actualAmount'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { cache } from '@/utils/cacheManager'
import { getBankAccountList } from '@/api/bankAccount'
import { AMOUNT_RECEIVE_TYPES } from '@/class/cargo/model/parameters/ClearingConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'ActualDialog',
  components: { searchItem, cargoAdvanceSelect, writeOffSearch, cargoCompanySelect },
  props: {
    visible: { type: Boolean, default: false },
    params: { type: Object, default: null },
    ar: { type: Number, required: true }
  },
  data() {
    return {
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      actualAmountTitle: '', // 销账抬头
      dialogDistroy: false, // 新增实收实付对话框销毁
      formItemWidth: 'width: 230px;', // 表单输入控件宽度统一控制
      innerVisible: false,
      actualAmount: {}, // 表单数据
      ourBankAccountArray: [], // 我方银行选项
      receiveTypeArray: [], // 收/付款方式选项
      selectTypeNames: TYPE_NAMES,
      showRecordButton: true, // 显示 收/付款记录按钮
      lockRecordButton: false, // 标记收/付款记录按钮lock状态 用于显示按钮文字
      // 新增/编辑 收付款表单参数
      settlementCompanyId: '', // 结算对象(公司)
      receiveType: null, // 收/付款方式
      cashTransferState: null, // 水单状态
      ourBankAccountId: 0, // 我方银行Id
      ourBankAccountNo: '',
      currency: '', // 币种
      ourBankObj: null, // 我方银行对象

      txtOurBankAccount: '', // 我方账号
      txtVoucherNo: '', // 凭证号
      ddlCurrency: '', // 币种
      nsActualAmount: 0, // 收/付款金额
      txtPayCompany: '', // 对方单位
      txtPayBank: '', // 对方银行
      txtPayAccountNo: '', // 对方账号
      dfPayReceiveDate: '', // 收/付款日期
      txtRemark: '', // 备注
      realSendReceiveDialog: {
        visible: false,
        isPrepay: -1,
        params: null,
        dialogClickRow: null // 新增实收实付中选中的行
      }
    }
  },
  computed: {
    lbPayReceive() {
      return this.ar ? this.$t('Payment.receipt') : this.$t('Payment.payment')
    },
    // 收付款金额
    lbAmount() {
      return this.ar ? this.$t('WriteOff.receiptAmount') : this.$t('WriteOff.paymentAmount')
    },
    // 收付款日期
    lbPayDate() {
      return this.ar ? this.$t('Payment.receiptDate') : this.$t('Payment.paymentDate')
    },
    // 收/付款记录按钮文字
    recordButtonText() {
      if (this.lockRecordButton) {
        return this.ar ? this.$t('WriteOff.cancelUsedReceiptRecord') : this.$t('WriteOff.cancelUsedPaymentRecord')
      } else {
        return this.ar ? this.$t('WriteOff.useReceiptRecord') : this.$t('WriteOff.usePaymentRecord')
      }
    },
    // 是否使用了收/付款记录
    useReceiptRecord() {
      return this.lockRecordButton
    },
    title() {
      return (this.actualAmount && this.actualAmount.uuid ? this.$t('common.btn.edit') : this.$t('common.btn.new')) + ' ' + this.lbPayReceive
    },
    currentOfficeUuid() {
      return this.$store.getters.currentOfficeUuid
    },
    tagName() {
      return this.$i18n.locale === 'zh' ? 'chineseName' : 'englishName'
    },
    i18nLocale() {
      return this.$i18n.locale
    },
    showTicketNo() {
      // CARGO-45570 在新增收款、付款记录时， 仅当选择“支票”“银行承兑汇票”“商业承兑汇票”时，显示该填写栏位
      return this.receiveType === ClearingConstants.RECEIVE_TYPE_CHECK.code ||
        this.receiveType === ClearingConstants.BANK_ACCEPTANCE_BILL.code ||
        this.receiveType === ClearingConstants.COMMERCIAL_ACCEPTANCE_BILL.code
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler(newVal) {
        // 获取发票抬头列表
        this.getInvoiceTitlesByOfficeCache.execute({ officeId: newVal }).then(res => {
          this.ourInvoiceTitleArray = res.data
        })
      }
    },
    visible(val) {
      this.innerVisible = val
    },
    innerVisible(val) {
      if (val) {
        this.actualAmount = this.params ? this.params : {}
        this.initData()
        this.lockRecordButton = false // 重置
      } else {
        this.$emit('update:visible', val)
      }
    },
    async currentOfficeUuid(val) {
      // 分公司切换时，初始化银行列表
      this.ourBankAccountArray = await getBankAccountList(val).then(res => res.data)
      this.ourBankAccountId = 0
    },
    i18nLocale() {
      // 国际化切换时销毁对话框
      this.dialogDistroy = true
      setTimeout(() => {
        this.dialogDistroy = false
      }, 1)
    }
  },
  async created() {
    // 初始化银行列表
    this.ourBankAccountArray = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => res.data)
    // 初始化收付类型
    for (const value of AMOUNT_RECEIVE_TYPES.values()) {
      this.receiveTypeArray.push(value)
    }
  },
  methods: {
    actualAmountTitleChangeEvent(p) {
      if (p) {
        this.actualAmountTitle = p.value
        this.actualAmount.actualAmountTitle = p.value
      } else {
        this.actualAmountTitle = ''
        this.actualAmount.actualAmountTitle = ''
      }
    },
    initData() {
      const actualAmount = this.actualAmount
      if (actualAmount) {
        // 结算对象(公司)
        this.settlementCompanyId = actualAmount.accountId
        // 收/付款方式
        this.receiveType = actualAmount.type || 0
        // 水单状态
        this.cashTransferState = actualAmount.cashTransferState || 0
        // 销账抬头
        this.actualAmountTitle = actualAmount.actualAmountTitle || ''
        // 币种
        this.currency = actualAmount.currency
        // 我方银行AccountId
        this.ourBankAccountNo = actualAmount.ourBankAccount
        if (this.ourBankAccountArray) {
          const bank = this.ourBankAccountArray.find(bank => bank.accountNo === actualAmount.ourBankAccount && bank.currency === actualAmount.ourBankCurrency)
          this.ourBankAccountId = bank ? bank.accountId : 0
          this.ourBankAccountNo = bank ? bank.accountNo : ''
        }
      }
    },
    // 保存/保存并新增 按钮事件
    async saveOrSaveAndAddHandler(onlySave) {
      const successHandler = onlySave ? this.saveResultHandler : this.saveAndCreateResultHandler
      if (this.validateForm()) {
        this.loading = getLoading()
        this.fillForm()
        const actualAmount = this.actualAmount
        actualAmount.branchId = this.$store.getters.currentOfficeId
        await actualAmountApi.saveActualAmount(actualAmount).then(resp => {
          successHandler()
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.$emit('refresh')
          if (onlySave) {
            this.innerVisible = false
          }
        }).catch().finally(() => {
          this.loading.close()
        })
      }
    },
    // 表单验证
    validateForm() {
      // CARGO-893 新增实收或者实付时，选择付款方式现金时不输入银行账号不能保存
      const isCheckOurBank = this.receiveType === ClearingConstants.RECEIVE_TYPE_CASH.code || this.receiveType === ClearingConstants.RECEIVE_TYPE_AGENT.code
      if (!isCheckOurBank && (this.ourBankAccountId === 0 || StrUtils.isEmpty(this.ourBankAccountNo))) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectOurBank'))
        return false
      } else if (!this.currency) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectCurrency'))
        return false
      } else if (!this.actualAmount.amount) {
        this.$message.info(this.$t('CargoMsg.Cargo_PlsInput') + this.lbPayReceive + this.$t('CargoMsg.Cargo_AmountF'))
        return false
      } else if (!this.actualAmount.payReceiveDate) {
        this.$message.info(this.$t('CargoMsg.Cargo_PlsInput') + this.lbPayReceive + this.$t('CargoMsg.Cargo_Date'))
        return false
      }
      return true
    },
    // 保存 成功回调
    async saveResultHandler() {
      this.actualAmount = {}
    },
    // 保存并新增 成功回调
    saveAndCreateResultHandler() {
      const model = {}
      const actualAmount = this.actualAmount
      // 结算对象
      model.accountId = actualAmount.accountId
      // 收款方式
      model.type = actualAmount.type
      // 我方银行
      model.ourBank = actualAmount.ourBank
      // 我方账号
      model.ourBankAccount = actualAmount.ourBankAccount
      // 我方币种
      model.ourBankCurrency = actualAmount.ourBankCurrency
      // 币种
      model.currency = actualAmount.currency
      // 日期
      model.payReceiveDate = actualAmount.payReceiveDate

      model.ar = this.ar
      model.branchId = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      model.currency = localCurrency
      this.actualAmount = model
    },
    // 选择实收/实付记录后确认赋值
    async enterHandler() {
      if (!this.realSendReceiveDialog.dialogClickRow) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('WriteOff.actualReceiptAndPayment'))
        return
      }
      await this.setActualAmount(this.realSendReceiveDialog.dialogClickRow)
      this.realSendReceiveDialog.visible = false
    },
    setActualAmount(selectedModel) {
      // this.actualAmount = selectedModel
      // this.initData()
      this.writeoffCurrency = selectedModel.currency
      this.receiveType = selectedModel.type
      this.cashTransferState = selectedModel.cashTransferState
      // 销账抬头
      this.actualAmountTitle = selectedModel.actualAmountTitle
      this.$nextTick(() => {
        if (this.ourBankAccountArray) {
          const bank = this.ourBankAccountArray.find(bank => bank.accountNo === selectedModel.ourBankAccount && bank.currency === selectedModel.ourBankCurrency)
          this.ourBankAccountId = bank ? bank.accountId : 0
          this.ourBankAccountNo = bank ? bank.accountNo : ''
          this.actualAmount.ourBankCurrency = bank ? bank.currency : ''
          this.actualAmount.ourBank = bank ? bank.bankChineseName : ''
          this.actualAmount.ourBankAccount = bank ? bank.accountNo : ''
        }
      })
      this.actualAmount.voucherNo = selectedModel.voucherNo
      this.actualAmount.paymentCompany = selectedModel.paymentCompany
      this.actualAmount.companyBank = selectedModel.companyBank
      this.actualAmount.companyBankAccount = selectedModel.companyBankAccount
      let modelRemainAmount = selectedModel.remainAmount
      if (selectedModel.currency !== this.currency) {
        const rate = RateUtil.getForeignExchangeRateByDate(this.currency, selectedModel.currency, new Date(), selectedModel.branchId)
        modelRemainAmount = rate * modelRemainAmount
      }
      selectedModel.uuid = null
      // 与cargoware的不一致：_realActualAmount
      // if (modelRemainAmount < this.actualAmount.amount) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.lbPayReceive + this.$t('CargoMsg.Cargo_AmountF') + NumberUtils.formatNumber(this.actualAmount.amount, 2))
      //   return
      // }
      // useReceiptRecord = true;
      // editing = false;
      this.lockRecordButton = true
      this.editing = false
      const writeoffByDifferentAccount = parseInt(cache.config.get('WriteoffByDifferentAccount')) === 1
      if (writeoffByDifferentAccount) {
        // 支付公司设为可编辑
        // callLater(function ():void {
        //   txtPayCompany.editable = true;
        // });
      }
    },
    closedHandler() {
      // 关闭对话框后，置空选中行数据
      this.realSendReceiveDialog.dialogClickRow = null
    },
    /** 下拉框change事件 **/
    companyIdChangeHandler(data) {
      this.settlementCompanyId = StrUtils.isEmpty(data.cmpIdx) ? 0 : data.cmpIdx
      this.actualAmount.accountId = StrUtils.isEmpty(data.cmpIdx) ? 0 : data.cmpIdx
    },
    // 收款方式
    receiveTypeChangeHandler(data) {
      this.receiveType = data.code
      if (data.code === 0) {
        this.ourBankAccountId = 0
        this.ourBankAccountNo = ''
        this.actualAmount.ourBank = ''
        this.actualAmount.ourBankAccount = ''
        this.actualAmount.ourBankCurrency = ''
        // this.currency = null
        // this.actualAmount.currency = null
      } else {
        this.checkCurrencyBankAccount(this.currency, true)
      }
    },
    // 水单状态
    cashTransferStateChangeHandler(data) {
      this.cashTransferState = data.value
      this.actualAmount.cashTransferState = data.value
    },
    // 我方银行
    ourBankChangeHandler(data) {
      this.ourBankObj = data
      this.actualAmount.ourBank = data.bankChineseName
      this.actualAmount.ourBankAccount = data.accountNo
      this.ourBankAccountNo = data.accountNo
      this.actualAmount.ourBankCurrency = data.currency || ''
      this.ourBankAccountId = data.accountId
    },
    // 币种
    currencyChangeHandler(data) {
      this.currency = data.code
      this.actualAmount.currency = data.code
      this.checkCurrencyBankAccount(this.currency, true)
    },
    /**
     * 根据各种自动关联账号
     * @param currency 页面币种
     * @param isChange 是否手动操作
     */
    checkCurrencyBankAccount(currency, isChange) {
      let bankAccount = this.getCurrencyBankAccount(currency, true)
      if (bankAccount == null) bankAccount = this.getCurrencyBankAccount(currency, false)
      if (bankAccount && (!this.useReceiptRecord || isChange)) {
        this.actualAmount.ourBank = bankAccount.bankChineseName
        this.actualAmount.ourBankAccount = bankAccount.accountNo
        this.actualAmount.ourBankCurrency = bankAccount.currency
        this.ourBankAccountId = bankAccount.accountId
        this.ourBankAccountNo = bankAccount.accountNo
      }
    },
    // 获取默认账号
    getCurrencyBankAccount(currency, isDefault) {
      let bank = null
      for (const bankAccount of this.ourBankAccountArray) {
        if (currency === bankAccount.currency) {
          if (!isDefault) {
            bank = bankAccount
            break
          } else if (bankAccount.defaultPayment) {
            bank = bankAccount
            break
          }
        }
      }
      return bank
    },
    // 收/付款记录按钮事件
    actualAmountRecordHandler() {
      if (this.lockRecordButton) {
        this.cancelUseActualAmountRecordHandler()
      } else {
        this.useActualAmountRecordHandler()
      }
    },
    // 收/付款记录选择
    useActualAmountRecordHandler() {
      this.realSendReceiveDialog.isRealSendReceive = true
      this.realSendReceiveDialog.ar = this.ar ? 1 : 0
      this.realSendReceiveDialog.isPrepay = 1 // 预付
      this.realSendReceiveDialog.accountId = this.accountId
      this.realSendReceiveDialog.visible = true
    },
    // 取消收/付款记录选择
    cancelUseActualAmountRecordHandler() {
      this.receiveType = 2
      this.cashTransferState = 0
      // 销账抬头
      this.actualAmountTitle = ''
      this.actualAmount.voucherNo = ''
      this.actualAmount.paymentCompany = ''
      this.actualAmount.companyBank = ''
      this.actualAmount.companyBankAccount = ''
      this.lockRecordButton = false
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    fillForm() {
      this.fillModel()
      const actualAmount = this.actualAmount
      actualAmount.remainAmount = actualAmount.amount
      actualAmount.isPrepay = true
      actualAmount.accountId = this.settlementCompanyId
      // actualAmount.payReceiveDate = this.dfPayReceiveDate
      // actualAmount.remark = this.txtRemark
      this.actualAmount = actualAmount
    },
    fillModel() {
      if (!this.actualAmount) return
      const actualAmount = this.actualAmount
      actualAmount.type = this.receiveType
      // actualAmount.ourBank = this.ourBankObj.bankChineseName
      // actualAmount.ourBankAccount = this.ourBankObj.accountNo
      // actualAmount.ourBankCurrency = this.ourBankObj.currency || ''
      // actualAmount.voucherNo = this.txtVoucherNo
      actualAmount.currency = this.currency
      // actualAmount.amount = this.nsActualAmount
      // actualAmount.paymentCompany = this.txtPayCompany
      // actualAmount.companyBank = this.txtPayBank
      // actualAmount.companyBankAccount = this.txtPayAccountNo
      actualAmount.cashTransferState = this.cashTransferState
      // 销账抬头
      actualAmount.actualAmountTitle = this.actualAmountTitle
      actualAmount.releaseState = ClearingConstants.BANK_SLIP_RELEASE_STATES.code
      actualAmount.preAmount = 0
      actualAmount.preBankSlipState = 0
      actualAmount.isPrePayment = false
      actualAmount.isBankSlip = false
      actualAmount.returnAmount = 0
    },
    ourBankAccountLabel(bankAccount) {
      if (bankAccount) {
        return '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.realSendReceiveDialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
}
</style>
